import { Box, Skeleton } from '@mui/material';
import React from 'react';

const TreeViewItemSkeleton = ({
    width,
}: {
    width: string;
}): React.ReactElement => (
    <Box sx={{ display: 'flex', alignItems: 'center', margin: '1em' }}>
        <Skeleton
            variant="rectangular"
            width={30}
            height={30}
            sx={{ borderRadius: '5px', marginRight: '1em' }}
        />
        <Skeleton variant="text" width={width} height={40} />
    </Box>
);

const TreeViewLoading = (): React.ReactElement => (
    <Box>
        <TreeViewItemSkeleton width="70%" />
        <TreeViewItemSkeleton width="50%" />
        <TreeViewItemSkeleton width="60%" />
    </Box>
);

export default TreeViewLoading;
